// extracted by mini-css-extract-plugin
export var aggregationCell = "_5x-p";
export var aggregationRow = "_5x-o";
export var borderlessSpinnerContainer = "_5x-3";
export var cardLayout = "_5x-6";
export var cardLayoutNoFooter = "_5x-a";
export var cardLayoutPageControl = "_5x-9";
export var cardLayoutWithFooter = "_5x-8";
export var closeIcon = "_5x-h";
export var columnHeaderSurface = "_5x-d";
export var columnHeaderSurfaceDragOverlay = "_5x-x";
export var columnHeaderSurfaceResizing = "_5x-u";
export var contextMenuAnchor = "_5x-1";
export var draggableColumnHeader = "_5x-v";
export var draggableColumnHeaderOverlay = "_5x-w";
export var expandIcon = "_5x-i";
export var expanded = "_5x-j";
export var filterDropdown = "_5x-k";
export var filterDropdownDivider = "_5x-f";
export var filterDropdownHeader = "_5x-n";
export var filterDropdownItem = "_5x-m";
export var filterDropdownModal = "_5x-l _5x-k";
export var filterItem = "_5x-e";
export var normalCellWithAdjustableBorder = "_5x-g";
export var pinButtonContainer = "_5x-q";
export var pinIcon = "_5x-r";
export var pinIconActive = "_5x-s";
export var spinner = "_5x-0";
export var spinnerContainer = "_5x-2";
export var tableContainer = "_5x-4";
export var tableContentDraggingColumns = "_5x-c";
export var tableContentInner = "_5x-7";
export var tableContentInnerFill = "_5x-b";
export var tableContentWrapper = "_5x-5";
export var viewButtonContainer = "_5x-t";